import { LogoClick } from "@/icons";
import Link from "next/link";
import { AnimatedHamburgerButton } from "../animatedHamburguerButton";

export const Header = () => {
  const navItems = [
    { label: "Como funciona", href: "/#como-funciona" },
    { label: "Galeria", href: "/galeria" },
    { label: "Depoimentos", href: "/#depoimentos" },
    // { label: "Benefícios", href: "/#beneficios" },
    { label: "Sobre nós", href: "/sobre-nos" },
    { label: "Blog", href: "/blog" },
    { label: "Médicos Click", href: "/seja-parceiro" },
    { label: "FAQ", href: "/duvidas-frequentes" },
  ];

  return (
    <header className="fixed bg-white left-0 top-0 z-40 flex w-full justify-between p-4 md:px-10 items-center">
      <Link href="/" aria-label="Ir para a página inicial da ClickCannabis">
        <LogoClick />
      </Link>

      <input type="checkbox" id="menu-toggle" className="hidden peer" />
      <label htmlFor="menu-toggle" className="lg:hidden cursor-pointer">
        <AnimatedHamburgerButton />
      </label>

      <nav className="hidden lg:block">
        <ul className="flex space-x-6">
          {navItems.map(({ label, href }) => (
            <li key={href}>
              <Link href={href} className="text-gray-700 hover:text-brand-dark">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};
